export class Card {
  public type: string = "";
  public last4: string = "";
  public mont: number;
  public year: number;
}